module.exports = __webpack_public_path__ + "static/img/njglyy.1a0f897.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/njglyy.png
// module id = 7svn
// module chunks = 0